import { Injectable } from '@angular/core';
import { B2BUser } from '../../../../model';
import { Converter } from '../../../../util/converter.service';
import { Occ } from '../../../occ-models';

@Injectable({
  providedIn: 'root',
})
export class OccB2BUserNormalizer implements Converter<Occ.B2BUser, B2BUser> {
  constructor() {}

  convert(source: Occ.B2BUser, target?: B2BUser): B2BUser {
    if (target === undefined) {
      target = { ...(source as any) };
    }
    target.email = source?.email;

    return target;
  }
}
